export const css = {
	titleBlock: '_1rRePOzT',
	' _key': 'apic-theme/apic/quiz-widgets/quizfolder'
};

export default css;
